import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FormDataState {
  exciseID: string;
  customerExecLeafNo: string;
  transporter: string;
  transporterPermitNo: string;
  vehicleNumber: string;
  serviceID?: string | null;
}

const initialState: FormDataState = {
  exciseID: "",
  customerExecLeafNo: "",
  transporter: "",
  transporterPermitNo: "",
  vehicleNumber: "",
  serviceID: null,
};

const formDataSlice = createSlice({
  name: "formData",
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<FormDataState>) => {
      state.exciseID = action.payload.exciseID;
      state.customerExecLeafNo = action.payload.customerExecLeafNo;
      state.transporter = action.payload.transporter;
      state.transporterPermitNo = action.payload.transporterPermitNo;
      state.vehicleNumber = action.payload.vehicleNumber;
      state.serviceID = action.payload.serviceID;
    },
  },
});

export const { setFormData } = formDataSlice.actions;

export default formDataSlice.reducer;
